/**
 *  test shortener
 * @param text
 * @param length
 */
export const textShortener = (text, length) => {
  if (text.length <= length) {
    return text;
  }
  return text.substr(0, length) + '...';
};

export const isMobilePhone = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const getEuropeanDate = (date) => {
  date = new Date(date);

  let d = date.getDate();
  let m = date.getMonth() + 1;
  let y = date.getFullYear();

  return (d <= 9 ? '0' + d : d) + '.' + (m <= 9 ? '0' + m : m) + '.' + y;
}
